'use client'

import { Factory } from '@/app/[locale]/(landing-page)/supplier/_components/supplier-data'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { ImageWithFallback as Image } from '@/components/common/image-with-fallback'

interface ImageGalleryProps {
  factory: Factory
}

export function ImageGallery({ factory }: ImageGalleryProps) {
  if (!factory.gallery || factory.gallery.length === 0) {
    return null
  }

  return (
    <div className='mt-8 columns-1'>
      {factory.gallery.map((image, index) => (
        <div key={index} className='mb-4 break-inside-avoid'>
          <Image
            src={ImageHelper.getImageUrlCdn(image)}
            alt={`${factory.slug}-gallery-${index}`}
            width={400}
            height={400}
            className='h-auto w-full rounded-lg object-cover'
          />
        </div>
      ))}
    </div>
  )
}
